export const fonts = {
  heading: '"sofia-pro", Verdana, sans-serif',
  body: '"sofia-pro", Verdana, sans-serif'
}
